<template>
  <button class="btn-info" @click="handleClick">
    <MaterialIcon :icon="icon" />
  </button>
</template>

<script lang="ts" setup>
import MaterialIcon from "@/ui/components/Icons/MaterialIcon/MaterialIcon.vue";

defineProps({
  icon: {
    type: String,
    default: "info"
  }
});

const emit = defineEmits<{
  (e: "click"): void;
}>();

const handleClick = () => emit("click");
</script>

<style lang="scss" scoped>
$chart-info: #737373;
$chart-info-background: #f5f5f5;
$chart-icons-w-h: 1em;

.btn-info {
  background: none;
  border: none;
  cursor: pointer;
  transition: hover 0.5s;
  padding: 4px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  .material-symbols-rounded {
    font-size: 16px;
    color: $chart-info;
    width: $chart-icons-w-h;
    height: $chart-icons-w-h;
    cursor: pointer;
  }
  &:hover {
    background: $chart-info-background;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>
